import { Provider } from 'react-redux';
import { Store } from './redux/Store';
import { SettingsProvider } from './contexts/SettingsContext';
import { AuthProvider } from './contexts/JWTAuthContext';
import routes from './routes';
import { useRoutes } from 'react-router-dom';
import { Theme } from './components';

const App = () => {
  const content = useRoutes(routes);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <Theme>
          <AuthProvider>{content}</AuthProvider>
        </Theme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
